import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class PhotoItemName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): PhotoItemName {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new PhotoItemName(value);
  }

  /** ラベル */
  static get label(): string {
    return '名前';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'L判';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key(): string {
    return 'photoItemName';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
